"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var account_1 = require("./account");

var pagination_1 = require("./pagination");

var class_validator_1 = require("class-validator");

var country_1 = require("./country");

var PromoterPublicDTO = function PromoterPublicDTO() {
  _classCallCheck(this, PromoterPublicDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], PromoterPublicDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], PromoterPublicDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterPublicDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterPublicDTO.prototype, "website", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterPublicDTO.prototype, "imgLogo", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], PromoterPublicDTO.prototype, "country", void 0);

exports.PromoterPublicDTO = PromoterPublicDTO;

var PromoterPrivateDTO =
/*#__PURE__*/
function (_PromoterPublicDTO) {
  _inherits(PromoterPrivateDTO, _PromoterPublicDTO);

  function PromoterPrivateDTO() {
    _classCallCheck(this, PromoterPrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoterPrivateDTO).apply(this, arguments));
  }

  return PromoterPrivateDTO;
}(PromoterPublicDTO);

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], PromoterPrivateDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsMobilePhone('fr-FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterPrivateDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], PromoterPrivateDTO.prototype, "enabled", void 0);

exports.PromoterPrivateDTO = PromoterPrivateDTO;

var PromoterCreationDTO = function PromoterCreationDTO() {
  _classCallCheck(this, PromoterCreationDTO);
};

__decorate([class_validator_1.IsMobilePhone('fr-FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsEmail(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "website", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "imgLogo", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], PromoterCreationDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterCreationDTO.prototype, "country", void 0);

exports.PromoterCreationDTO = PromoterCreationDTO;

var PromoterUpdateDTO =
/*#__PURE__*/
function (_account_1$AccountUpd) {
  _inherits(PromoterUpdateDTO, _account_1$AccountUpd);

  function PromoterUpdateDTO() {
    _classCallCheck(this, PromoterUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoterUpdateDTO).apply(this, arguments));
  }

  return PromoterUpdateDTO;
}(account_1.AccountUpdateDTO);

__decorate([class_validator_1.IsMobilePhone('fr-FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsEmail(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "website", void 0);

__decorate([class_validator_1.IsUrl(), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "imgLogo", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], PromoterUpdateDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], PromoterUpdateDTO.prototype, "country", void 0);

exports.PromoterUpdateDTO = PromoterUpdateDTO;

var PromoterFilterDTO = function PromoterFilterDTO() {
  _classCallCheck(this, PromoterFilterDTO);
};

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", Array)], PromoterFilterDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], PromoterFilterDTO.prototype, "usedOnly", void 0);

exports.PromoterFilterDTO = PromoterFilterDTO;
var PromoterOrderEnum;

(function (PromoterOrderEnum) {
  PromoterOrderEnum["createDate"] = "createDate";
})(PromoterOrderEnum = exports.PromoterOrderEnum || (exports.PromoterOrderEnum = {}));

var PromoterPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(PromoterPaginationResponse, _pagination_1$Paginat);

  function PromoterPaginationResponse() {
    _classCallCheck(this, PromoterPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoterPaginationResponse).apply(this, arguments));
  }

  return PromoterPaginationResponse;
}(pagination_1.PaginationResponse);

exports.PromoterPaginationResponse = PromoterPaginationResponse;